import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e2344f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-grid p-pt-5"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-1" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-spin pi-spinner",
    style: {"font-size":"2rem"}
  })
], -1))
const _hoisted_4 = { class: "p-col-11" }
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = { class: "p-col-2 p-offset-10 app-legend" }
const _hoisted_7 = { class: "p-grid p-pt-5" }
const _hoisted_8 = { class: "p-col-12" }
const _hoisted_9 = { class: "p-d-flex" }
const _hoisted_10 = { class: "p-col-12 p-mb-2 p-mr-4" }
const _hoisted_11 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_12 = { class: "p-mb-2 p-mr-4 p-ml-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_16 = { class: "p-mb-2 p-mr-4 p-ml-2" }
const _hoisted_17 = { class: "p-mb-2 p-mr-4 p-ml-2" }
const _hoisted_18 = { class: "p-input-icon-left" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_20 = { class: "p-mb-2 p-mr-4 p-ml-2" }
const _hoisted_21 = { class: "p-mb-2 p-mr-4 p-ml-2" }
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" > ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_legend = _resolveComponent("form-legend")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Image = _resolveComponent("Image")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('validation.loading')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_form_legend, {
                  collapsed: true,
                  "legend-items": [{name: 'form.validate', styleClass: 'validate'}, {name: 'form.reValidate', styleClass: 'reValidate'}, {name: 'form.uncertainRecord', styleClass: 'uncertainRecord'}],
                  toggleable: true
                }, null, 8, ["legend-items"])
              ])
            ]),
            _createVNode(_component_DataTable, {
              ref: "ExpertValidationRecordsTable",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event)),
              lazy: true,
              loading: _ctx.loading,
              paginator: true,
              rowHover: true,
              rows: 500,
              totalRecords: _ctx.totalRecords,
              value: _ctx.features,
              filterDisplay: "row",
              sortMode: "multiple",
              selection: _ctx.selectedRecords,
              "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRecords) = $event)),
              dataKey: "RECORD_ID",
              scrollable: true,
              scrollDirection: "both",
              scrollHeight: "800px",
              stripedRows: "",
              onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onPage($event))),
              currentPageReportTemplate: "{first} - {last} / {totalRecords} Records",
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              rowsPerPageOptions: [10,25,50,100,500,1000,2000,5000,10000],
              onSort: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSort($event))),
              resizableColumns: true,
              columnResizeMode: "expand",
              style: {"min-width":"100% !important"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('validation.title')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      (_ctx.headers.length > 0)
                        ? (_openBlock(), _createBlock(_component_MultiSelect, {
                            key: 0,
                            modelValue: _ctx.selectedValidationRecordHeaders,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValidationRecordHeaders) = $event)),
                            class: "p-col-12 p-multiselect-sm",
                            filter: true,
                            options: _ctx.allHeaders,
                            placeholder: _ctx.$t('choose_headers'),
                            display: "chip",
                            optionLabel: "name"
                          }, {
                            option: _withCtx((slotProps) => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.name)), 1)
                              ])
                            ]),
                            chip: _withCtx((slotProps) => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(slotProps.value.name)), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options", "placeholder"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('validation.selectValidationStatus')), 1),
                    _hoisted_13,
                    _hoisted_14
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Dropdown, {
                      id: "validationState",
                      modelValue: _ctx.selectedValidationState,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedValidationState) = $event)),
                      options: _ctx.admValidationStatusOptions,
                      optionLabel: "LABEL",
                      optionValue: "ID",
                      placeholder: _ctx.$t('choose_dropdown'),
                      filter: true,
                      filterPlaceholder: _ctx.$t('search'),
                      class: "appControlButton"
                    }, null, 8, ["modelValue", "options", "placeholder", "filterPlaceholder"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.filters['global'].value,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                          _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInput($event)))
                        ],
                        class: "p-inputtext-sm appControlButton appTableSearchBar",
                        placeholder: _ctx.$t('search_table')
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          label: _ctx.$t('validate'),
                          class: "p-button-success appControlButton",
                          onClick: _ctx.save
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          label: _ctx.$t('cancel'),
                          class: "p-button-primary appControlButton",
                          onClick: _ctx.cancel
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.showMessages)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_ctx.state === 'error')
                          ? (_openBlock(), _createBlock(_component_Message, {
                              key: 0,
                              severity: "error",
                              closable: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('validation.error')) + " ", 1),
                                _hoisted_24,
                                _hoisted_25,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.errors.records, (error, key) => {
                                  return (_openBlock(), _createElementBlock("span", { key: key }, [
                                    _hoisted_26,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('table.RECORD_ID')) + ":   " + _toDisplayString(key), 1),
                                    _hoisted_27,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(error, (err, field) => {
                                      return (_openBlock(), _createElementBlock("span", { key: field }, [
                                        _createTextVNode("   - '" + _toDisplayString(_ctx.$t('validation.' + field)) + "' -- " + _toDisplayString(err) + " ", 1),
                                        _hoisted_28
                                      ]))
                                    }), 128)),
                                    _hoisted_29
                                  ]))
                                }), 128)),
                                _hoisted_30
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.state === 'success')
                          ? (_openBlock(), _createBlock(_component_Message, {
                              key: 1,
                              severity: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('validation.success')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('no_records')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  class: "editColumn smallTableColumn",
                  selectionMode: "multiple"
                }),
                (_ctx.showColumn('ADM_VALIDATION_STATUS'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      header: _ctx.$t('table.ADM_VALIDATION_STATUS'),
                      sortable: true,
                      class: "largeTableColumn",
                      field: "ADM_VALIDATION_STATUS"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(slotProps.data.ADM_VALIDATION_STATUS === 'bereit zum Validieren' ? 'tableLabel validate' : 'tableLabel reValidate')
                        }, _toDisplayString(slotProps.data.ADM_VALIDATION_STATUS), 3)
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  header: _ctx.$t('table.RECORD_ID'),
                  class: "smallTableColumn",
                  field: "RECORD_ID",
                  sortable: true
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", {
                      class: _normalizeClass({ pError: _ctx.recordsWithErrors.includes(slotProps.data.RECORD_ID.toString())})
                    }, _toDisplayString(slotProps.data.RECORD_ID), 3)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  class: "largeTableColumn",
                  header: _ctx.$t('table.TAXON_NAME'),
                  field: "TAXON_NAME",
                  sortable: true
                }, null, 8, ["header"]),
                (_ctx.showColumn('IF_FLORAPP_REFERENCE_WORK'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 1,
                      header: _ctx.$t('table.IF_FLORAPP_REFERENCE_WORK'),
                      class: "smallTableColumn",
                      field: "IF_FLORAPP_REFERENCE_WORK",
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SUGGESTED_TAXON_NAME'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 2,
                      header: _ctx.$t('table.SUGGESTED_TAXON_NAME'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SUGGESTED_TAXON_NAME"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(slotProps.data.SUGGESTED_TAXON_NAME ? 'tableLabel uncertainRecord': '')
                        }, _toDisplayString(slotProps.data.SUGGESTED_TAXON_NAME), 3)
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SUGGESTED_TAXON_DESCRIPTION'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 3,
                      header: _ctx.$t('table.SUGGESTED_TAXON_DESCRIPTION'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SUGGESTED_TAXON_DESCRIPTION"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SUGGESTED_TAXON_PUBLICATION'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 4,
                      header: _ctx.$t('table.SUGGESTED_TAXON_PUBLICATION'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SUGGESTED_TAXON_PUBLICATION"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SUGGESTED_TAXON_COMMENT'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 5,
                      header: _ctx.$t('table.SUGGESTED_TAXON_COMMENT'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SUGGESTED_TAXON_COMMENT"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('CERTAINTY'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 6,
                      header: _ctx.$t('table.CERTAINTY'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "CERTAINTY"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(slotProps.data.CERTAINTY==='unsicher bestimmt (cf.)' ? 'tableLabel uncertainRecord': 'tableLabel validate')
                        }, _toDisplayString(slotProps.data.CERTAINTY), 3)
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('DETERMINATION_TYPE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 7,
                      header: _ctx.$t('table.DETERMINATION_TYPE'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "DETERMINATION_TYPE"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('PROJECT'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 8,
                      class: "smallTableColumn",
                      field: "PROJECT",
                      header: _ctx.$t('table.PROJECT'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  class: "smallTableColumn",
                  header: _ctx.$t('table.RECORD_DATE'),
                  field: "RECORD_DATE",
                  sortable: true
                }, null, 8, ["header"]),
                (_ctx.showColumn('LEG'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 9,
                      header: _ctx.$t('table.LEG'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "LEG"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('COMMENT_RECORD'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 10,
                      class: "smallTableColumn",
                      field: "COMMENT_RECORD",
                      header: _ctx.$t('table.COMMENT_RECORD'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('IMAGE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 11,
                      header: _ctx.$t('table.IMAGE'),
                      class: "smallTableColumn",
                      field: "IMAGE"
                    }, {
                      body: _withCtx((slotProps) => [
                        (slotProps.data.IMAGE)
                          ? (_openBlock(), _createBlock(_component_Image, {
                              key: 0,
                              src: slotProps.data.IMAGE,
                              imageClass: "app-image",
                              onClick: ($event: any) => (_ctx.toggleImage(slotProps.data.IMAGE))
                            }, null, 8, ["src", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SUBSTRATE_COARSE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 12,
                      header: _ctx.$t('table.SUBSTRATE_COARSE'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SUBSTRATE_COARSE"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SUBSTRATE_FINE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 13,
                      header: _ctx.$t('table.SUBSTRATE_FINE'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SUBSTRATE_FINE"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('X'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 14,
                      class: "smallTableColumn",
                      header: _ctx.$t('table.X'),
                      sortable: true,
                      field: "X"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", {
                          class: _normalizeClass((slotProps.data.X > 2900000 || slotProps.data.X < 2100000) ? 'tableLabel uncertainRecord' : '')
                        }, _toDisplayString(slotProps.data.X), 3)
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('Y'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 15,
                      class: "smallTableColumn",
                      header: _ctx.$t('table.Y'),
                      sortable: true,
                      field: "Y"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", {
                          class: _normalizeClass((slotProps.data.Y > 1400000 || slotProps.data.X < 1000000) ? 'tableLabel uncertainRecord' : '')
                        }, _toDisplayString(slotProps.data.Y), 3)
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('PRECISION_XY'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 16,
                      class: "smallTableColumn",
                      field: "PRECISION_XY",
                      header: _ctx.$t('table.PRECISION_XY'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('Z_MEASURED'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 17,
                      class: "smallTableColumn",
                      field: "Z_MEASURED",
                      header: _ctx.$t('table.Z_MEASURED'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('COMMENT_SITE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 18,
                      class: "smallTableColumn",
                      field: "COMMENT_SITE",
                      header: _ctx.$t('table.COMMENT_SITE'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('DET'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 19,
                      header: _ctx.$t('table.DET'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "DET"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('VIS'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 20,
                      header: _ctx.$t('table.VIS'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "VIS"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('REPORTER'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 21,
                      header: _ctx.$t('table.REPORTER'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "REPORTER"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('CERTIFICATES'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 22,
                      header: _ctx.$t('table.CERTIFICATES'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "CERTIFICATES"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('WOODY_PLANT'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 23,
                      header: _ctx.$t('table.WOODY_PLANT'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "WOODY_PLANT"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('FRUITBODY'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 24,
                      header: _ctx.$t('table.FRUITBODY'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "FRUITBODY"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('WOOD_DEGRADATION'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 25,
                      header: _ctx.$t('table.WOOD_DEGRADATION'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "WOOD_DEGRADATION"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('WOOD_QUALITY'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 26,
                      header: _ctx.$t('table.WOOD_QUALITY'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "WOOD_QUALITY"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SPORE_TYPE_RUSTS'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 27,
                      header: _ctx.$t('table.SPORE_TYPE_RUSTS'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SPORE_TYPE_RUSTS"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SEXUAL_STAGE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 28,
                      header: _ctx.$t('table.SEXUAL_STAGE'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "SEXUAL_STAGE"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('HOST_PLANT'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 29,
                      header: _ctx.$t('table.HOST_PLANT'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "HOST_PLANT"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('HOST_FUNGUS'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 30,
                      header: _ctx.$t('table.HOST_FUNGUS'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "HOST_FUNGUS"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('HOST_LICHEN'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 31,
                      header: _ctx.$t('table.HOST_LICHEN'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "HOST_LICHEN"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('LITERATURE'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 32,
                      class: "smallTableColumn",
                      field: "LITERATURE",
                      header: _ctx.$t('table.LITERATURE'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('PUBLICATION'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 33,
                      class: "smallTableColumn",
                      field: "PUBLICATION",
                      header: _ctx.$t('table.PUBLICATION'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('SPECIMEN_LABEL'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 34,
                      class: "smallTableColumn",
                      field: "SPECIMEN_LABEL",
                      header: _ctx.$t('table.SPECIMEN_LABEL'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('LOCALITY_DESCRIPTION'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 35,
                      class: "smallTableColumn",
                      field: "LOCALITY_DESCRIPTION",
                      header: _ctx.$t('table.LOCALITY_DESCRIPTION'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('DELARZE_HABITAT'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 36,
                      header: _ctx.$t('table.DELARZE_HABITAT'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "DELARZE_HABITAT"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.showColumn('FLORAPP_VEGETATION_SURVEY'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 37,
                      class: "smallTableColumn",
                      field: "FLORAPP_VEGETATION_SURVEY",
                      header: _ctx.$t('table.FLORAPP_VEGETATION_SURVEY'),
                      sortable: true
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  header: _ctx.$t('table.PRESENCE'),
                  sortable: true,
                  class: "smallTableColumn",
                  field: "PRESENCE"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(slotProps.data.PRESENCE!=='Present' ? 'tableLabel uncertainRecord': 'tableLabel validate')
                    }, _toDisplayString(slotProps.data.PRESENCE), 3)
                  ]),
                  _: 1
                }, 8, ["header"]),
                (_ctx.showColumn('LAST_EDITED_BY'))
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 38,
                      header: _ctx.$t('table.LAST_EDITED_BY'),
                      sortable: true,
                      class: "smallTableColumn",
                      field: "LAST_EDITED_BY"
                    }, null, 8, ["header"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  header: _ctx.$t('table.APP_USER_COMMENT'),
                  sortable: true,
                  field: "appUserComment",
                  class: "editColumn largeTableColumn"
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputText, {
                      class: "textInputColumn",
                      onChange: ($event: any) => (_ctx.addUserComment(slotProps.data.RECORD_ID, $event.target.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(slotProps.data.APP_USER_COMMENT), 1)
                      ]),
                      _: 2
                    }, 1032, ["onChange"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  header: _ctx.$t('table.ADM_COMMENT'),
                  sortable: true,
                  class: "editColumn largeTableColumn",
                  field: "admComment"
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputText, {
                      class: "textInputColumn",
                      onChange: ($event: any) => (_ctx.addAdmComment(slotProps.data.RECORD_ID, $event.target.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(slotProps.data.ADM_COMMENT), 1)
                      ]),
                      _: 2
                    }, 1032, ["onChange"])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["filters", "loading", "totalRecords", "value", "selection"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_Dialog, {
        visible: _ctx.showImage,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showImage) = $event)),
        breakpoints: {'960px': '75vw', '640px': '100vw'},
        style: {width: '50vw'},
        dismissableMask: "",
        maximizable: ""
      }, {
        default: _withCtx(() => [
          (_ctx.img)
            ? (_openBlock(), _createBlock(_component_Image, {
                key: 0,
                src: _ctx.img,
                imageStyle: "width: 100%"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}